import ProductsFeatured from './ProductsFeatured';

export default ProductsFeatured;